import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const updateGroupRouting = createAsyncThunk("LeadRoutingGroups/updateGroupRouting", async (data, thunkAPI) => {
    let groupId=data.id
    delete data.id
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/lead-routing/groups/${groupId}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.data?.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
